export default __webpack_public_path__ + "static/media/jacket.3d8039a6.jpg";